import toast from 'react-hot-toast';

/**
 * The toast a gated page shows as it turns an unauthorized visitor away. Those gates run
 * in a mount effect, which React.StrictMode (index.js) runs twice, so a plain
 * toast.error() stacked the same message twice. A stable id per message makes
 * react-hot-toast show it once however often the gate fires.
 *
 * @param {string} message
 */
export const toastPermissionDenied = (message) =>
  toast.error(message, { id: `permission-denied:${message}` });

/**
 * The same dedupe for any error a page raises from a mount effect or its first load
 * (a redirect gate, a failed fetch), which StrictMode would otherwise show twice.
 *
 * @param {string} message
 */
export const toastErrorOnce = (message) =>
  toast.error(message, { id: `error:${message}` });
